import envConfig from '../../config';
import { getValidToken } from './RestClient';

export async function buildPrivateImageUrl(imageId, imageSize) {
  try {
    const token = await getValidToken();
    const tempid = imageId.split('.');
    const ext = tempid.pop();
    const uuid = imageId.slice(0, imageId.length - (1 + ext.length));
    const sizeSuffix = imageSize ? `_${imageSize}` : '';
    const objectKey = `${uuid}${sizeSuffix}.${ext}`;
    const requestedId = imageSize ? objectKey : imageId;
    return `${envConfig.CLOUDFRONT_URL}${requestedId}?token=${token}&env=${envConfig.ENV}`;
  } catch (e) {
    return {};
  }
}

export function buildPublicImageUrl(imageId, imageSize) {
  const tempId = imageId.split('.');
  const ext = tempId.pop();
  const uuid = imageId.slice(0, imageId.length - (1 + ext.length));
  const sizeSuffix = imageSize ? `_${imageSize}` : '';
  const objectKey = `${uuid}${sizeSuffix}.${ext}`;
  const requestedId = imageSize ? objectKey : imageId;
  return `${envConfig.PUBLIC_ASSETS_URL}${requestedId}`;
}
export function buildPrivateAssetImageUrl(imageId, imageSize) {
  const tempId = imageId.split('.');
  const ext = tempId.pop();
  const uuid = imageId.slice(0, imageId.length - (1 + ext.length));
  const sizeSuffix = imageSize ? `_${imageSize}` : '';
  const objectKey = `${uuid}${sizeSuffix}.${ext}`;
  const requestedId = imageSize ? objectKey : imageId;
  return `${envConfig.PRIVATE_ASSETS_URL}${requestedId}`;
}
